import React, { useState, useEffect } from 'react';

// redux
import { useSelector } from 'react-redux';
import { selectTimelineEmployeeList } from '_redux/slices/timeline/employees';
import { selectSelectedTimeline } from '_redux/slices/timeline/timeline-areas';

// styles
import { selectUsedTheme } from '_redux/slices/timeline/theme';

/**
 * EmployeeCount - Displays employee count in a circular badge
 * @param {number} count - The number of employees to display
 * @param {string} size - Size variant: 'small', 'medium', 'large' (default: 'medium')
 */
const EmployeeCount = () => {

    const usedTheme = useSelector(selectUsedTheme);

    const employees = useSelector(selectTimelineEmployeeList);
    const selectedTimeline = useSelector(selectSelectedTimeline);
    const [count, setCount] = useState(0);

    useEffect(() => {
        if (employees) {
            setCount(employees.length);
        }
    }, [employees])

    const displayText = selectedTimeline?.title 
        ? `${count} ${selectedTimeline.title} Staff` 
        : `${count} Staff Online`;

    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
        }}>
            <p
                style={{
                    color: usedTheme.JOB_LIST_COLOR,
                    fontSize: "14px",
                    fontWeight: "500",
                    margin: "0px",
                    width: "fit-content",
                    paddingInline: "2px",
                }}
            >
                {displayText}
            </p>
    </div>
    );
};

export default React.memo(EmployeeCount);
